import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { Col, Form, InputNumber, Row, Button, Checkbox } from 'antd';

@withRouter
@inject('store')
@observer
class GeneralFormComponent extends Component {
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        let delayEnabled = getFieldValue('delay_enabled');
        delayEnabled = delayEnabled === undefined ? true : delayEnabled;

        return (
            <Fragment>
                <Row gutter={24} style={{ padding: '10px 0px', borderBottom: '1px #2e324a solid' }}>
                    <Col xs={12} md={2}>
                        <Form.Item label="Enabled">
                            {getFieldDecorator('enabled', {
                                valuePropName: 'checked',
                                initialValue: true
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={2}>
                        <Form.Item label="Qty" required={true}>
                            {getFieldDecorator('qty', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={2}>
                        <Form.Item label="Entry Spread" required={true}>
                            {getFieldDecorator('spread', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={2}>
                        <Form.Item label="Take Profit %" required={true}>
                            {getFieldDecorator('tp', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={2}>
                        <Form.Item label="Trading Zone Enabled">
                            {getFieldDecorator('trading_zone_enabled', {
                                valuePropName: 'checked',
                                initialValue: true
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={2}>
                        <Form.Item label="Delay Enabled">
                            {getFieldDecorator('delay_enabled', {
                                valuePropName: 'checked',
                                initialValue: true
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>
                    {delayEnabled ? (
                        <Col md={2}>
                            <Form.Item label="Delay (mins)" required={true}>
                                {getFieldDecorator('delay', {
                                    initialValue: 0,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Field is required'
                                        }
                                    ]
                                })(<InputNumber />)}
                            </Form.Item>
                        </Col>
                    ) : null}

                    <Col md={4}>
                        <div style={{ paddingTop: 42 }}>
                            <Button
                                icon="delete"
                                type="danger"
                                shape="circle-outline"
                                onClick={this.props.deleteLayer.bind(this)}
                            ></Button>
                        </div>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}

export const LayerForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        return data;
    },
    onValuesChange(props, changedFields, allallValues) {
        props.updateLayer(allallValues);
    }
})(GeneralFormComponent);



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/SettingsView/LayerForm.js